import { Controller, useForm } from "react-hook-form";
import Icon from "../icons";
import Button from "../elements/button";
import { Dropdown, Menu } from "../Dropdown";
import { filterConfigType } from "../../_config/types";
import { useEffect, useState } from "react";
import Label from "../elements/form/fromLabel";
import SelectBox from "../elements/form/selectBox";
import Input from "../elements/form/input";
import Datepicker from "../elements/form/datepicker";
import { getSelectedOptions } from "../../_common/functions";


interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    config: filterConfigType[]
    filters: any
    onUpdate?: (filters: any) => void
}



const Filters: React.FC<Props> = ({ _ref, config, filters, onUpdate = () => { } }) => {

    const [appliedFilters, setAppliedFilters] = useState<filterConfigType[]>([])
    const { control, register, getValues, reset, handleSubmit, setValue, formState: { errors } } = useForm<any>();

    const onSubmit = (formData: any) => {
        let filters: any = {};
        appliedFilters.forEach((filter: filterConfigType) => {
            if (filter.type == 'dropdown') {
                if(filter.isMulti === false){
                    filters[filter.key] = formData[filter.key]?.value
                } else {
                filters[filter.key] = formData[filter.key]?.map((option: any) => option.value)
                }
            } else {
                filters[filter.key] = formData[filter.key]
            }
        })
        onUpdate(filters)
        _ref?.current?.close();
    }

    const onClose = () => {
        _ref?.current?.close();
    }

    const addFilter = (filter: filterConfigType) => {
        setAppliedFilters([...appliedFilters, filter])
    }
    const removeFilter = (filter: filterConfigType) => {
        setValue(filter.key, null)
        setAppliedFilters(appliedFilters.filter((_filter: filterConfigType) => _filter.name != filter.name))
    }

    useEffect(() => {
        let appliedFilters: filterConfigType[] = [];
        console.log('....filters ==>',filters, config)
        Object.keys(filters).forEach((key: string) => {
            let filter: filterConfigType = config.filter((_filter: filterConfigType) => _filter.key == key)[0]
            if (filter) {
                appliedFilters.push(filter)
            }
        })

        console.log('...appliedFilters...',appliedFilters)
        setAppliedFilters(appliedFilters)

        let resetValues: any = {}
        Object.keys(filters).forEach((key: string) => {
            let filter: filterConfigType = config.filter((_filter: filterConfigType) => _filter.key == key)[0]
            if (filter?.type == 'dropdown') {
                if(filter.isMulti === false){
                    resetValues[key] = filter.options?.filter((option: any) => option.value == filters[key])[0]
                } else {
                resetValues[key] = getSelectedOptions(filters[key], filter.options as any)
                }
            } else {
                resetValues[key] = filters[key]
            }
        })
        reset(resetValues)
    }, [filters])

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[30rem] p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='flex items-center justify-between border-b border-[#dddcdc] pb-2 mb-2'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>Filters</p>
                        <button onClick={onClose} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3 min-h-[14rem]'>
                        {appliedFilters?.map((filter: filterConfigType, i: number) => (
                            <div key={`applied-facility-filter-${i}`}>
                                <div className="flex items-center justify-between mb-2">
                                    <Label
                                        text={filter.name}
                                    />
                                    <Icon name="delete" className="text-gray-300 hover:text-red-500" onClick={() => { removeFilter(filter) }} />
                                </div>

                                <Controller
                                    name={filter.key}
                                    control={control}
                                    render={({ field: { value, onChange } }) => {
                                        switch (filter.type) {
                                            case 'text':
                                                return <Input
                                                    type='text'
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                            case 'dropdown':
                                                if(filter.async){
                       
                                                return <SelectBox
                                                    async={true}
                                                    value={value}
                                                    onChange={onChange}
                                                    menuPlacement={i > 0 ? 'top' : 'auto'}
                                                    asyncLoadOptions={filter.async as any}
                                                    isMulti={filter.isMulti === false ? false : true}
                                                    isClearable={true}
                                                />
                                                } else {
                                                    return <SelectBox
                                                    value={value}
                                                    onChange={onChange}
                                                    menuPlacement={i > 0 ? 'top' : 'auto'}
                                                    options={filter.options?(filter.options as any):[]}
                                                    isMulti={filter.isMulti === false ? false : true}
                                                    isClearable={true}
                                                />
                                                }
                                            case 'date':
                                                return <Datepicker
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                            case 'date-range':
                                                return <Datepicker
                                                    type={'range'}
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                            case 'number':
                                                return <Input
                                                    type='number'
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                            default:
                                                return <Input
                                                    type='text'
                                                    value={value}
                                                    onChange={onChange}
                                                />
                                        }
                                    }}
                                />
                            </div>
                        ))}

                    </div>

                    <div className='flex justify-between gap-2 border-t border-[#dddcdc] pt-2'>
                        <div>
                            <Dropdown position="top">
                                <Dropdown.Button>
                                    <Button size="sm" theme='secondary'>
                                        <Icon name='add-filter' size={1} />
                                        Add Filter
                                    </Button>
                                </Dropdown.Button>
                                <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                                    {config?.map((filter: filterConfigType, i: number) => {
                                        const applied: boolean = appliedFilters.filter((_filter: filterConfigType) => _filter.name == filter.name).length > 0;
                                        if (applied) { return null }
                                        return <Menu key={`facility-filter-menu-${i}`} onClick={() => { addFilter(filter) }}>{filter.name}</Menu>
                                    })}
                                </Dropdown.Content>
                            </Dropdown>


                        </div>
                        <div className="flex gap-2 items-center">
                            <Button type="button" size="sm" theme='light' onClick={onClose}>Cancel</Button>
                            <Button size="sm" type="submit" >Apply Filter</Button>
                        </div>
                    </div>

                </form>

            </div>
            <form method="dialog" className="modal-backdrop" onClick={onClose}>

            </form>
        </dialog>
    );
};

export default Filters;